import { Component, ChangeDetectionStrategy, HostBinding, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { version } from 'packageJson';
import { CommonLoaderComponent } from './components/common-loader/common-loader.component';
import { ThemeService } from './services/theme.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonLoaderComponent],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'hrService';
  @HostBinding('attr.app-version') appVersion = version;
  private themeService = inject(ThemeService);

  ngOnInit(): void {
    this.themeService.initTheme();
  }
}

